import React, { useContext } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Header from './components/Header/Header'
import Menu from './components/Menu/Menu'

import { CharacterProvider } from './contexts/character'
import { SubStatsProvider } from './contexts/subStats'
import { DBProvider } from './contexts/databases'
import { AuthProvider } from './contexts/auth'

import { UIContext } from './contexts/ui'

import './app.scss'
import './sb-admin-2.css'

import Simulator from './pages/Simulator'
import EXPScaler from './pages/EXPScaler'
import Refine from './pages/Refine'
import PatchNote from './pages/PatchNote'
import Contact from './pages/Contact'
import About from './pages/About'
import Login from './pages/auth/Login'
import Register from './pages/auth/Register'
import ForgotPassword from './pages/auth/ForgotPassword'
import ResetPassword from './pages/auth/ResetPassword'
import VerifyEmail from './pages/auth/VerifyEmail'
import Account from './pages/auth/Account'

function App(props) {
	const { Theme } = useContext(UIContext)
	return (
		<div className='mainContainer'>
			<AuthProvider>
				<DBProvider>
					<CharacterProvider>
						<SubStatsProvider>
							<React.StrictMode>
								<BrowserRouter>
									<Menu />
									<div className={'mainPage mainBGColor' + Theme}>
										<Header />
										<Routes>
											<Route path='/expscaler'        element={<EXPScaler />} />
											<Route path='/refine'           element={<Refine />} />
											<Route path='/news'             element={<PatchNote />} />
											<Route path='/contact'          element={<Contact />} />
											<Route path='/about'            element={<About />} />
											<Route path='/login'            element={<Login />} />
											<Route path='/register'         element={<Register />} />
											<Route path='/forgot-password'  element={<ForgotPassword />} />
											<Route path='/reset-password'   element={<ResetPassword />} />
											<Route path='/verify-email'     element={<VerifyEmail />} />
											<Route path='/account'          element={<Account />} />
											<Route path='*'                 element={<Simulator />} />
										</Routes>
									</div>
								</BrowserRouter>
							</React.StrictMode>
						</SubStatsProvider>
					</CharacterProvider>
				</DBProvider>
			</AuthProvider>
		</div>
	)
}

export default App
